module.exports = __webpack_public_path__ + "media/images/icon_tag-44e8f543b9fea594a3d85f71cb6062a6.png";